'use client';

import * as React from 'react';
import { Checkbox } from '@/components/Checkbox';

import { createDemoClient } from '../createDemoClient';

const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@/components/Checkbox": { Checkbox } } } });

export default ClientProvider;
